/* eslint import/prefer-default-export: 0 */

const ALERT_CONFIG = {
  offline: {
    severity: {
      text: 'warning',
      level: 1,
    },
  },
}

const DEFAULT = {
  severity: {
    text: 'error',
    level: 2,
  },
}

const OK = {
  severity: {
    text: 'ok',
    level: 0,
  },
}

export function alertConfig(key) {
  return ALERT_CONFIG[key] || DEFAULT
}

export function overallAlertSeverity(alerts = []) {
  return alerts.map((alert) => alertConfig(alert.type))
    .reduce(
      (prev, current) => (prev.severity.level > current.severity.level ? prev : current),
      OK,
    )
}
